import { DefaultTags }             from "_common/seo";
import { defaultServerProps }      from "_common/ssrWrapper";
import BlogsPage                   from "_components/pages/blogs/blogsPage.js";
import { getCategories, getPosts } from "_services/api/blogs";

const component = props => {
	return (
		<>
			<DefaultTags
				desc     = "Rooter Blogs"
				endpoint = "/blogs"
				title    = "Rooter Blogs"
			/>

			<BlogsPage { ...props } />
		</>
	);
};

const getServerSideProps = async context => defaultServerProps ( context, async defaultProps => {

	const results    = await Promise.allSettled (
		[
			getCategories (),
			getPosts ()
		]
	);
	let catgeoryData = [];
	let postsData    = [];

	results.forEach ( ( result, index ) => {
		if ( result.status === "fulfilled" ) {
			switch ( index ) {
				case 0:
					catgeoryData = result.value;
					break;

				case 1:
					postsData = result.value;
					break;

			}
		}
	} );

	let mainData = catgeoryData?.map ( cat => {
		let filteredPosts     = postsData?.filter ( post => post?.categories?.[0] === cat?.id );
		let updatedPostSchema = filteredPosts?.map ( post => {

			return {
				id              : post?.id,
				date            : post?.date,
				content         : post?.content?.rendered,
				// featuredImage   : post?.better_featured_image?.source_url ?? post?.jetpack_featured_media_url ?? "",
				featuredImage   : post?.jetpack_featured_media_url ?? "",
				yoast_head_post : post?.yoast_head ?? "",
				tags            : post?.tags,
				title           : post?.title?.rendered,
				slug            : post?.slug
			};
		} );

		return {
			id             : cat.id,
			name           : cat.name,
			slug           : cat.slug,
			yoast_head_cat : cat?.yoast_head ?? "",
			posts          : updatedPostSchema
		};

	} );

	if ( !mainData ) {
		return {
			notFound: true
		};
	}

	/* context.res.setHeader (
    "Cache-Control",
    "public, s-maxage=300, stale-while-revalidate=600"
  ); */

	return {
		props: {
			...defaultProps,
			data     : mainData,
			noLayout : true,
			noAuth   : true,
			postsData
		}
	};
} );

export { getServerSideProps };

export default component;
